// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ScrollableHeadline_wrapper__uo7JU","pinWrap":"ScrollableHeadline_pinWrap__sbEk7","mediaWrapper":"ScrollableHeadline_mediaWrapper__8llso"};